module.exports = __webpack_public_path__ + "img/Light Orange.3bfda5c5.svg";